import { levelType } from 'json/index'
// 表格表头
export let tableLabels = [
  {
    label: '任务名称',
    value: 'pointsTask.content'
  },
  {
    label: '说明文字',
    value: 'pointsTask.description'
  },
  {
    label: '单次积分',
    value: 'pointsTask.unitAndValue'
  },
  {
    label: '上限',
    value: 'pointsTask.limitTypeCopy'
  },
  {
    label: '上限次数',
    value: 'pointsTask.limitTimesCopy'
  },
  {
    label: '发布时间',
    value: 'pointsTask.createdDateCopy'
  },
  {
    label: '已发积分合计',
    value: 'totalProvide'
  },
  {
    label: '状态',
    value: 'pointsTask.statusCopy'
  }
]
// 选择商品的列表顶部筛选
export let filterItems = [
  {
    label: '发放时间',
    type: 'time-slot',
    value: 'publishTime',
    startName: 'startDate',
    endName: 'endDate'
  }, {
    label: '用户等级',
    type: 'select',
    clearable: true,
    value: 'levelCode', // 需返回数据的字段名
    options: levelType
  }
]
